import * as J from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as so } from "../../helpers/edgeMask.js";
const ao = {
  name: "Chromatic1",
  collection: "chromatic",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (m) => {
    const {
      vec3: E,
      vec4: O,
      time: T,
      mix: n,
      sin: d,
      float: o,
      pow: c,
      uv: f,
      color: t
    } = J, l = t("#0a638a"), r = t("#dfb036"), N = t("#aaa832"), u = t("#2b84ff"), C = t("#299fd1"), S = t("#ffc607"), p = 0.2, I = 1, R = -0.1, D = 0.1, G = 0.12, A = 0.5, L = 10, g = 0.7, b = 0.03, Y = 0.55, F = 0.5, v = 0.2, w = 1, x = 1, U = 0.05, B = 0.02, s = f(), { correctedUV: V } = Z(), _ = oo(s, G, A, L), W = c(l, o(2.2)), h = c(r, o(2.2)), y = c(N, o(2.2)), k = c(u, o(2.2)), H = n(
      W,
      h,
      s.x
    ), P = n(
      k,
      y,
      s.x
    ), K = n(
      H,
      P,
      s.y
    ), a = _.x.sub(0.5), i = _.y.sub(0.5), M = i.mul(a).add(i.mul(a)).negate(), e = o(1).add(
      o(g).mul(
        d(
          M.add(T.mul(m.speed.uniform).mul(0.025)).div(b)
        )
      )
    ), Q = so({
      inset: p,
      softness: I,
      offsetX: R,
      offsetY: D
    }), X = E(e, e, e).mul(Q).mul(Y), z = n(
      S.mul(B),
      C.mul(U),
      s.y.mul(s.x)
    ), j = $(F)(V), q = O(
      z.add(K.mul(X)).sub(j),
      1
    );
    return to(q, r, v, w, x);
  }
};
export {
  ao as componentDefinition,
  ao as default
};
